export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5218.6e79c794.jpg";